<template>
<Layout>
  <div class="section content">
    <h1 class="is-size-5">O nas</h1>
    <span class="is-size-7">
      <p>
        778mobile GmbH<br>
        HRB 79227 // USt-IdNr: DE303966009<br>
        Mei Li-BERLIT, manager director<br>
        Am Wehrhahn 50<br>
        DE-40211 Düsseldorf - Germany<br>
        Telefon: <a href="tel:221253450">221253450</a><br>
        E-Mail: <a href="mailto:778mobile.pl@silverlines.info">778mobile.pl@silverlines.info</a>
      </p>
    </span>
  </div>
</Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'

export default {
  name: 'Imprint',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangKyf/PL/Imprint.vue